import { getWindow } from './get-window';

/**
 * Invoke a callback asynchronously in `requestAnimationFrame` for DOM operation optimization.
 * NOTE: If run in server environment, the callback will be invoke directly.
 * @param callback The callback to invoke in `requestAnimationFrame.
 */
export function requestAnimationFrameAsync<T>(
  callback: (time?: number) => T,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const win = getWindow();
    if (!win) {
      try {
        const result = callback();
        resolve(result);
      } catch (error) {
        reject(error);
      }
      return;
    }
    win.requestAnimationFrame((time) => {
      try {
        const result = callback(time);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    });
  });
}
